import { Routes, Route, Navigate, useLocation } from "react-router-dom";

import React, { Suspense, useEffect } from "react";
import "./App.scss";
import "../src/assets/HOQ-Icons/fontello-2772519b/css/fontello.css";
import { PublicRoutes, PrivateRoutes, CommonRoutes } from "./routes";
import NonAuth from "./components/NonAuthLayout";
import AuthLayout from "./components/AuthLayout";
import Headers from "./components/AuthLayout/Header";
import Footer from "./components/AuthLayout/Footer";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { RECAPTCHA_SITE_KEY } from "./helpers/constant";
import Loading from "./components/AuthLayout/Loading";

function App() {
  const { pathname } = useLocation();
  const formatedPathName = pathname.split("/")[1];

  // Add routes where header should be hidden
  const hideHeaderRoutes = ['signin', 'signup', 'forgot-password', 'reset-password', 'verify-account'];
  const shouldShowHeader = !hideHeaderRoutes.includes(formatedPathName);
  const AddCapchaRoutes = ["signin", "signup", "forgot-password"];
  const shouldAddCapcha = AddCapchaRoutes.includes(formatedPathName);
  const isLoggedIn = localStorage.getItem("HOQ_Token");

  return (
    <Suspense fallback={<Loading height="h-[100vh]"></Loading>}>
      <Routes>
        {/* Public Routes */}
        {PublicRoutes.map(({ path, exact, component: Component,common }) => {
          // Only handle non-404 public routes here
          if (path !== "*") {
            return isLoggedIn ? (
              <Route
                key={path}
                path={path}
                exact={exact}
                element={<Navigate to="/" />}
              />
            ) : (
              <Route
                key={path}
                path={path}
                exact={exact}
                element={
                  <Suspense fallback={<Loading></Loading>}>
                    {shouldAddCapcha ? (
                      <GoogleReCaptchaProvider
                        reCaptchaKey={RECAPTCHA_SITE_KEY}
                      >
                        {shouldShowHeader && <Headers />}
                        <div
                          className={` ${
                            shouldShowHeader
                              ? "min-h-[calc(100vh-8vh)] pt-[8vh]"
                              : ""
                          } `}
                        >
                          <Suspense fallback={<Loading height='h-[100vh]'></Loading>}>
                            <Component />
                          </Suspense>
                        </div>
                        {shouldShowHeader && <Footer />}
                      </GoogleReCaptchaProvider>
                    ) : (
                      <>
                        {shouldShowHeader && <Headers />}
                        <div
                          className={` ${
                            shouldShowHeader
                              ? "min-h-[calc(100vh-8vh)] pt-[8vh]"
                              : ""
                          } `}
                        >
                          <Suspense fallback={<Loading></Loading>}>
                            <Component />
                          </Suspense>
                        </div>
                        {shouldShowHeader && <Footer />}
                      </>
                    )}
                  </Suspense>
                }
              />
            );
          }
          return null;
        })}

        {/*Common Routes */}
        {CommonRoutes.map(({ path, exact, component: Component }) => {
          return (
            <Route
              key={path}
              path={path}
              exact={exact}
              element={
                <Suspense fallback={<Loading></Loading>}>
                  <Component />
                </Suspense>
              }
            />
          );
        })}

        {/* Private Routes with AuthLayout */}
        <Route path="/" element={<AuthLayout />}>
          {PrivateRoutes.map(({ path, exact, component: Component }) => {
            // For the 404 route in private routes
            if (path === "*") {
              return (
                <Route
                  key={path}
                  path={path}
                  exact={exact}
                  element={
                    isLoggedIn ? <Component /> : <Navigate to="/signin" />
                  }
                />
              );
            }

            // For other private routes
            return isLoggedIn ? (
              <Route
                key={path}
                path={path}
                exact={exact}
                element={<Component />}
              />
            ) : (
              <Route
                key={path}
                path={path}
                exact={exact}
                element={<Navigate to="/signin" />}
              />
            );
          })}
        </Route>
      </Routes>
    </Suspense>
  );
}

export default App;
